import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import RestaurantDetailPage from "./RestaurantDetail";
import { getData, serverURL } from "../../../../Services/Fetchnodeservices";

// ─────────────────────────────────────────────────────────────────────────────
// API CONFIG
// ─────────────────────────────────────────────────────────────────────────────
const fetchResto = async ({ page, limit, search, status, ready, onOff, locationFilter }) => {
  try {
    const response = await getData("restaurant/Restrunts");
    const data = response;
    
    console.log("response restaurants:", data);
    
    let restaurantsList = Array.isArray(data) ? data : (data.data || data.items || []);
    
    // Apply filters
    let filtered = [...restaurantsList];
    
    if (search) {
      filtered = filtered.filter(r => 
        (r.name && r.name.toLowerCase().includes(search.toLowerCase())) ||
        (r.owner_mobile && r.owner_mobile.includes(search)) ||
        (r.id && r.id.toString().includes(search)) ||
        (r.organisation_name && r.organisation_name.toLowerCase().includes(search.toLowerCase()))
      );
    }
    if (status && status !== "All") {
      filtered = filtered.filter(r => {
        const itemStatus = r.status === "1" ? "Active" : "Inactive";
        return itemStatus === status;
      });
    }
    if (ready && ready !== "All") {
      filtered = filtered.filter(r => {
        const itemReady = r.open_status === "1" ? "Yes" : "No";
        return itemReady === ready;
      });
    }
    if (onOff && onOff !== "All") {
      filtered = filtered.filter(r => {
        const itemOnOff = r.open_status === "1" ? "ON" : "OFF";
        return itemOnOff === onOff;
      });
    }
    if (locationFilter && locationFilter !== "All") {
      filtered = filtered.filter(r => {
        const restaurantCity = r.city || r.address?.split(',').pop()?.trim() || "Unknown";
        const restaurantArea = r.area || r.locality || "";
        return restaurantCity === locationFilter || restaurantArea === locationFilter;
      });
    }
    
    // Pagination
    const start = (page - 1) * limit;
    const paginated = filtered.slice(start, start + limit);
    
    // Map database fields to component expected fields
    const mappedData = paginated.map(item => ({
      id: item.id,
      restroId: item.id,
      name: item.name || "",
      organisation_name: item.organisation_name || item.name || "",
      owner_name: item.owner_name || "",
      owner_mobile: item.owner_mobile || "",
      contact: item.owner_mobile || item.contact || "",
      email: item.email || "",
      address: item.address || "",
      city: item.city || item.address?.split(',').pop()?.trim() || "Unknown",
      area: item.area || item.locality || "",
      meet_to: item.meet_to || "",
      interestedin_zaptodoor: item.interestedin || "",
      other_person_name: item.other_person_name || "",
      other_person_mobile: item.other_person_mobile || "",
      restropic: item.pic || item.r_logo || null,
      status: item.status === "1" ? "Active" : "Inactive",
      ready: item.open_status === "1" ? "Yes" : "No",
      onOff: item.open_status === "1" ? "ON" : "OFF",
      shiftStart: item.shift_start || "10:00 AM",
      shiftEnd: item.shift_end || "10:00 PM",
      rating: parseFloat(item.rating) || 4.0,
      totalRatings: parseInt(item.total_ratings) || 0,
      totalReviews: parseInt(item.total_reviews) || 0,
      totalPayments: parseFloat(item.platform_charge) || 0,
      pendingPayments: 0,
      completedPayments: 0,
      password: item.password || "",
      pic: item.pic || item.r_logo || null,
      description: item.details || "",
      cuisine: item.cuisine || "",
      platform_charge: parseFloat(item.platform_charge) || 0,
      handling_charge: parseFloat(item.handling_charge) || 0,
      gst_percentage: parseFloat(item.gst_percentage) || 0,
      platform_share: parseFloat(item.comission) || 0,
      pay_perclick: 0,
      wallet: parseFloat(item.wallet) || 0,
      bank_name: item.bank_name || "",
      ifsc_code: item.ifsc || "",
      account_holder: item.account_holder || "",
      account_number: item.account_number || "",
      upi: item.upi || "",
      gst_number: item.gst_number || "",
      gst_pic: item.gst_pic || null,
      food_license_number: item.food_license_number || "",
      food_license_pic: item.food_license_pic || null,
      // ✅ FIXED: Added latitude and longitude from API response
      latitude: item.latitude || null,
      longitude: item.longitude || null,
      phn_otp1: item.contact || "",
      phn_otp2: "",
      login_session: item.login_session || "",
      refer_code: item.myreferal || "",
      created_at: item.created_at,
      updated_at: item.updated_at,
      paid: item.paid === "1",
      menu: [],
      schedule: [
        { day: "Monday", openTime: "09:00", closeTime: "23:00", isClosed: false },
        { day: "Tuesday", openTime: "09:00", closeTime: "23:00", isClosed: false },
        { day: "Wednesday", openTime: "09:00", closeTime: "23:00", isClosed: false },
        { day: "Thursday", openTime: "09:00", closeTime: "23:00", isClosed: false },
        { day: "Friday", openTime: "09:00", closeTime: "23:00", isClosed: false },
        { day: "Saturday", openTime: "10:00", closeTime: "00:00", isClosed: false },
        { day: "Sunday", openTime: "10:00", closeTime: "22:00", isClosed: false }
      ]
    }));
    
    return {
      data: mappedData,
      total: filtered.length,
      page: page,
      limit: limit
    };
  } catch (error) {
    console.error("Error fetching restaurants:", error);
    return {
      data: [],
      total: 0,
      page: page,
      limit: limit
    };
  }
};

// ─────────────────────────────────────────────────────────────────────────────
// ICONS
// ─────────────────────────────────────────────────────────────────────────────
const TrashIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>);
const SearchIcon = () => (<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>);
const ChevronLeftIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="15 18 9 12 15 6"/></svg>);
const ChevronRightIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="9 18 15 12 9 6"/></svg>);
const PlusIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>);
const StarIcon = () => (<svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>);
const PaymentIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="2" y="6" width="20" height="12" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/><line x1="16" y1="14" x2="18" y2="14"/></svg>);
const LocationPinIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="12" r="3"/></svg>);

// ─────────────────────────────────────────────────────────────────────────────
// SUB-COMPONENTS
// ─────────────────────────────────────────────────────────────────────────────

// ✅ FIXED RESTAURANT AVATAR COMPONENT - Shows actual image from correct path
const RestaurantAvatar = ({ pic, name, isDark }) => {
  const [imageError, setImageError] = useState(false);
  
  // Get clean filename from pic path
  const getCleanFilename = (picPath) => {
    if (!picPath || picPath.trim() === "") return null;
    // If picPath already has the full path, extract just the filename
    if (picPath.includes('/')) {
      return picPath.split('/').pop();
    }
    return picPath;
  };
  
  const filename = getCleanFilename(pic);
  // ✅ Correct path: public/public/uploadnew/upload/
  const imageUrl = filename ? `${serverURL}/public/uploadnew/upload/${filename}` : null;
  
  if (!imageUrl || imageError) {
    // Show placeholder with initials
    const initial = name?.charAt(0) || "🍔";
    return (
      <div style={{
        width: "28px", height: "28px", borderRadius: "50%",
        background: "linear-gradient(135deg, #3b82f6, #8b5cf6)",
        display: "flex", alignItems: "center", justifyContent: "center",
        fontSize: "12px", fontWeight: 600, color: "#fff",
      }}>
        {initial}
      </div>
    );
  }
  
  return (
    <img
      src={imageUrl}
      alt={name}
      onError={() => setImageError(true)}
      style={{
        width: "28px",
        height: "28px",
        borderRadius: "50%",
        objectFit: "cover",
        border: `1px solid ${isDark ? "#2a3145" : "#e5e7eb"}`
      }}
    />
  );
};

const StatusBadge = ({ status }) => {
  const config = {
    Active:   { bg: "rgba(20,184,166,0.15)", color: "#14b8a6", dot: "#14b8a6" },
    Inactive: { bg: "rgba(148,163,184,0.12)", color: "#94a3b8", dot: "#94a3b8" },
  };
  const c = config[status] || config.Inactive;
  return (
    <div style={{
      display: "inline-flex", alignItems: "center", gap: "4px",
      padding: "2px 8px 2px 6px", borderRadius: "16px",
      background: c.bg, border: `1px solid ${c.bg}`,
    }}>
      <div style={{ width: "4px", height: "4px", borderRadius: "50%", background: c.dot }} />
      <span style={{ fontSize: "10px", fontWeight: 600, color: c.color }}>{status}</span>
    </div>
  );
};

const ReadyBadge = ({ ready }) => {
  const config = {
    Yes: { bg: "rgba(20,184,166,0.15)", color: "#14b8a6" },
    No:  { bg: "rgba(245,158,11,0.12)", color: "#f59e0b" },
  };
  const c = config[ready] || config.No;
  return (
    <span style={{
      padding: "2px 8px", borderRadius: "10px", fontSize: "10px",
      fontWeight: 600, background: c.bg, color: c.color,
    }}>{ready}</span>
  );
};

const OnOffBadge = ({ value }) => {
  const config = {
    ON:  { bg: "rgba(34,197,94,0.15)", color: "#22c55e" },
    OFF: { bg: "rgba(148,163,184,0.12)", color: "#94a3b8" },
  };
  const c = config[value] || config.OFF;
  return (
    <span style={{
      padding: "2px 8px", borderRadius: "10px", fontSize: "10px",
      fontWeight: 700, background: c.bg, color: c.color,
    }}>{value}</span>
  );
};

const Checkbox = ({ checked, onChange }) => (
  <div onClick={onChange} style={{
    width: "14px", height: "14px", borderRadius: "3px",
    border: checked ? "2px solid #3b82f6" : "2px solid #3a4460",
    background: checked ? "#3b82f6" : "transparent",
    display: "flex", alignItems: "center", justifyContent: "center",
    cursor: "pointer", transition: "all 0.15s ease",
  }}>
    {checked && (
      <svg width="8" height="8" viewBox="0 0 12 12" fill="none">
        <path d="M2 6l3 3 5-5" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    )}
  </div>
);

const Toast = ({ message, type, onClose }) => (
  <div style={{
    position: "fixed", bottom: "24px", right: "24px", zIndex: 999,
    background: type === "error" ? "#1a0a0a" : "#0a1a0a",
    border: `1px solid ${type === "error" ? "rgba(239,68,68,0.4)" : "rgba(16,185,129,0.4)"}`,
    borderRadius: "10px", padding: "10px 16px",
    display: "flex", alignItems: "center", gap: "8px",
    boxShadow: "0 8px 32px rgba(0,0,0,0.5)",
    animation: "slideUp 0.25s ease",
  }}>
    <div style={{ width: "6px", height: "6px", borderRadius: "50%", background: type === "error" ? "#ef4444" : "#10b981" }} />
    <span style={{ fontSize: "12px", color: type === "error" ? "#fca5a5" : "#6ee7b7", flex: 1 }}>{message}</span>
    <span onClick={onClose} style={{ cursor: "pointer", color: "#64748b", fontSize: "14px" }}>×</span>
  </div>
);

const DeleteConfirmModal = ({ isOpen, restaurantName, onConfirm, onCancel, isDark }) => {
  if (!isOpen) return null;
  
  return (
    <div style={{
      position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
      background: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center",
      justifyContent: "center", zIndex: 1000, animation: "fadeIn 0.2s ease"
    }}>
      <div style={{
        background: isDark ? "#141824" : "#ffffff",
        borderRadius: "12px", padding: "20px", maxWidth: "350px",
        width: "90%", border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0"
      }}>
        <h3 style={{ color: isDark ? "#f1f5f9" : "#1e293b", marginBottom: "8px", fontSize: "16px" }}>Confirm Delete</h3>
        <p style={{ color: isDark ? "#94a3b8" : "#64748b", marginBottom: "16px", fontSize: "13px" }}>
          Are you sure you want to delete <strong>{restaurantName}</strong>?
        </p>
        <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
          <button onClick={onCancel} style={{
            padding: "6px 14px", borderRadius: "6px", border: "1px solid #1e2740",
            background: "transparent", color: isDark ? "#94a3b8" : "#64748b", cursor: "pointer", fontSize: "12px"
          }}>Cancel</button>
          <button onClick={onConfirm} style={{
            padding: "6px 14px", borderRadius: "6px", border: "none",
            background: "#ef4444", color: "white", cursor: "pointer", fontSize: "12px"
          }}>Delete</button>
        </div>
      </div>
    </div>
  );
};

const RestaurantMenuModal = ({ restaurant, onClose, isDark }) => {
  return (
    <div style={{
      position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
      background: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center",
      justifyContent: "center", zIndex: 1000
    }}>
      <div style={{
        background: isDark ? "#141824" : "#ffffff", borderRadius: "12px",
        padding: "20px", width: "90%", maxWidth: "600px", maxHeight: "80vh",
        overflow: "auto"
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "16px" }}>
          <h3 style={{ color: isDark ? "#f1f5f9" : "#1e293b", fontSize: "16px" }}>Menu - {restaurant.name}</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "#64748b", fontSize: "18px", cursor: "pointer" }}>×</button>
        </div>
        <p style={{ textAlign: "center", color: "#64748b", padding: "30px", fontSize: "13px" }}>Menu management coming soon</p>
      </div>
    </div>
  );
};

const ScheduleModal = ({ isOpen, restaurant, scheduleItems, onUpdate, onDelete, onAdd, onClose, onSave, isDark }) => {
  const [newItem, setNewItem] = useState({ day: "Monday", openTime: "09:00", closeTime: "17:00", isClosed: false });
  
  if (!isOpen) return null;
  
  const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  
  return (
    <div style={{
      position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
      background: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center",
      justifyContent: "center", zIndex: 1000
    }}>
      <div style={{
        background: isDark ? "#141824" : "#ffffff", borderRadius: "12px",
        padding: "20px", width: "90%", maxWidth: "800px", maxHeight: "80vh",
        overflow: "auto"
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "16px" }}>
          <h3 style={{ color: isDark ? "#f1f5f9" : "#1e293b", fontSize: "16px" }}>Schedule - {restaurant?.name}</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "#64748b", fontSize: "18px", cursor: "pointer" }}>×</button>
        </div>
        
        <div style={{ marginBottom: "16px" }}>
          <h4 style={{ color: isDark ? "#f1f5f9" : "#1e293b", fontSize: "13px", marginBottom: "10px" }}>Add New Schedule</h4>
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", alignItems: "center" }}>
            <select value={newItem.day} onChange={(e) => setNewItem({ ...newItem, day: e.target.value })} style={{ padding: "5px 8px", background: isDark ? "#0d1117" : "#f8fafc", border: "1px solid #1e2740", borderRadius: "4px", color: isDark ? "#f1f5f9" : "#1e293b", fontSize: "12px" }}>
              {days.map(day => <option key={day}>{day}</option>)}
            </select>
            <input type="time" value={newItem.openTime} onChange={(e) => setNewItem({ ...newItem, openTime: e.target.value })} style={{ padding: "5px 8px", background: isDark ? "#0d1117" : "#f8fafc", border: "1px solid #1e2740", borderRadius: "4px", color: isDark ? "#f1f5f9" : "#1e293b", fontSize: "12px" }} />
            <input type="time" value={newItem.closeTime} onChange={(e) => setNewItem({ ...newItem, closeTime: e.target.value })} style={{ padding: "5px 8px", background: isDark ? "#0d1117" : "#f8fafc", border: "1px solid #1e2740", borderRadius: "4px", color: isDark ? "#f1f5f9" : "#1e293b", fontSize: "12px" }} />
            <label style={{ display: "flex", alignItems: "center", gap: "4px", fontSize: "11px", color: isDark ? "#64748b" : "#475569" }}>
              <input type="checkbox" checked={newItem.isClosed} onChange={(e) => setNewItem({ ...newItem, isClosed: e.target.checked })} /> Closed
            </label>
            <button onClick={() => {
              if (scheduleItems.some(item => item.day === newItem.day)) {
                alert("Schedule for this day already exists");
                return;
              }
              onAdd(newItem);
              setNewItem({ day: "Monday", openTime: "09:00", closeTime: "17:00", isClosed: false });
            }} style={{ padding: "5px 12px", background: "#4a6cf7", border: "none", borderRadius: "4px", color: "white", cursor: "pointer", fontSize: "11px" }}>Add</button>
          </div>
        </div>
        
        <div>
          <h4 style={{ color: isDark ? "#f1f5f9" : "#1e293b", fontSize: "13px", marginBottom: "10px" }}>Current Schedule</h4>
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            {scheduleItems.map((item, idx) => (
              <div key={idx} style={{
                display: "flex", alignItems: "center", gap: "10px", padding: "6px",
                border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", borderRadius: "6px", flexWrap: "wrap"
              }}>
                <span style={{ width: "90px", fontWeight: 600, color: isDark ? "#f1f5f9" : "#1e293b", fontSize: "12px" }}>{item.day}</span>
                <input type="time" value={item.openTime} onChange={(e) => onUpdate(idx, { ...item, openTime: e.target.value })} style={{ padding: "4px 6px", background: isDark ? "#0d1117" : "#f8fafc", border: "1px solid #1e2740", borderRadius: "4px", fontSize: "11px" }} />
                <span style={{ fontSize: "11px" }}>-</span>
                <input type="time" value={item.closeTime} onChange={(e) => onUpdate(idx, { ...item, closeTime: e.target.value })} style={{ padding: "4px 6px", background: isDark ? "#0d1117" : "#f8fafc", border: "1px solid #1e2740", borderRadius: "4px", fontSize: "11px" }} />
                <label style={{ fontSize: "11px", display: "flex", alignItems: "center", gap: "3px" }}>
                  <input type="checkbox" checked={item.isClosed} onChange={(e) => onUpdate(idx, { ...item, isClosed: e.target.checked })} /> Closed
                </label>
                <button onClick={() => onDelete(idx)} style={{ marginLeft: "auto", background: "none", border: "none", color: "#ef4444", cursor: "pointer", fontSize: "11px" }}>Delete</button>
              </div>
            ))}
          </div>
        </div>
        
        <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end", marginTop: "16px" }}>
          <button onClick={onClose} style={{ padding: "6px 14px", background: "transparent", border: "1px solid #1e2740", borderRadius: "6px", color: isDark ? "#94a3b8" : "#64748b", cursor: "pointer", fontSize: "12px" }}>Cancel</button>
          <button onClick={onSave} style={{ padding: "6px 14px", background: "#4a6cf7", border: "none", borderRadius: "6px", color: "white", cursor: "pointer", fontSize: "12px" }}>Save Schedule</button>
        </div>
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// MAIN COMPONENT - RestaurantTable
// ─────────────────────────────────────────────────────────────────────────────
const RestaurantTable = ({ isDark = true }) => {
  const navigate = useNavigate();
  const [restaurants, setRestaurants] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [readyFilter, setReadyFilter] = useState("All");
  const [onOffFilter, setOnOffFilter] = useState("All");
  const [locationFilter, setLocationFilter] = useState("All");
  const [uniqueLocations, setUniqueLocations] = useState([]);
  const [selected, setSelected] = useState(new Set());
  const [page, setPage] = useState(1);
  const [perPage] = useState(10);
  const [toast, setToast] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(null);
  const [showDetailPage, setShowDetailPage] = useState(null);
  const [showMenuModal, setShowMenuModal] = useState(null);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [scheduleItems, setScheduleItems] = useState([]);
  const [scheduleRestaurant, setScheduleRestaurant] = useState(null);
  const [locationStats, setLocationStats] = useState({});

  const showToast = (message, type = "success") => { 
    setToast({ message, type }); 
    setTimeout(() => setToast(null), 3500); 
  };
  
  const handleAddRestaurantClick = () => {
    navigate("/Dashboard/addrestaurant", { state: { mode: "add" } });
  };
  
  const handleEditRestaurantClick = (restaurant) => {
    navigate("/Dashboard/addrestaurant", { state: { mode: "edit", restaurantData: restaurant } });
  };
  
  useEffect(() => { 
    const t = setTimeout(() => { 
      setDebouncedSearch(search); 
      setPage(1); 
    }, 500); 
    return () => clearTimeout(t); 
  }, [search]);
  
  const extractUniqueLocations = (restaurantsData) => {
    const locations = new Set();
    locations.add("All");
    restaurantsData.forEach(restaurant => {
      const city = restaurant.city || restaurant.address?.split(',').pop()?.trim();
      const area = restaurant.area || restaurant.locality;
      if (city && city !== "Unknown") locations.add(city);
      if (area && area !== "Unknown") locations.add(area);
    });
    return Array.from(locations);
  };
  
  const calculateLocationStats = (restaurantsData) => {
    const stats = {};
    restaurantsData.forEach(restaurant => {
      const city = restaurant.city || restaurant.address?.split(',').pop()?.trim() || "Unknown";
      const area = restaurant.area || restaurant.locality || "";
      const locationKey = area || city;
      if (locationKey && locationKey !== "Unknown") {
        stats[locationKey] = (stats[locationKey] || 0) + 1;
      }
    });
    return stats;
  };
  
  const fetchRestaurants = useCallback(async () => { 
    setLoading(true); 
    try { 
      const res = await fetchResto({ 
        page, 
        limit: perPage, 
        search: debouncedSearch, 
        status: statusFilter, 
        ready: readyFilter, 
        onOff: onOffFilter,
        locationFilter: locationFilter
      }); 
      setRestaurants(res.data || []); 
      setTotal(res.total || 0);
      
      const allRes = await fetchResto({ 
        page: 1, 
        limit: 1000, 
        search: "", 
        status: "All", 
        ready: "All", 
        onOff: "All",
        locationFilter: "All"
      });
      const uniqueLocs = extractUniqueLocations(allRes.data || []);
      setUniqueLocations(uniqueLocs);
      
      const stats = calculateLocationStats(allRes.data || []);
      setLocationStats(stats);
    } catch (err) { 
      showToast(`Failed to load: ${err.message}`, "error"); 
    } finally { 
      setLoading(false); 
    } 
  }, [page, perPage, debouncedSearch, statusFilter, readyFilter, onOffFilter, locationFilter]);
  
  useEffect(() => { 
    fetchRestaurants(); 
  }, [fetchRestaurants]);
  
  // ✅ FIXED: Added latitude and longitude to mappedRestaurants
  const mappedRestaurants = restaurants.map((r, idx) => ({ 
    id: r.id, 
    sn: (page - 1) * perPage + idx + 1, 
    restroId: r.restroId, 
    status: r.status, 
    ready: r.ready, 
    onOff: r.onOff, 
    shiftStart: r.shiftStart, 
    shiftEnd: r.shiftEnd, 
    name: r.name,
    organisation_name: r.organisation_name || r.name,
    owner_name: r.owner_name,
    contact: r.owner_mobile || r.contact,
    password: r.password, 
    pic: r.pic, 
    schedule: r.schedule, 
    rating: r.rating, 
    totalRatings: r.totalRatings, 
    totalPayments: r.totalPayments, 
    pendingPayments: r.pendingPayments, 
    completedPayments: r.completedPayments, 
    menu: r.menu, 
    address: r.address, 
    email: r.email, 
    description: r.description, 
    cuisine: r.cuisine,
    city: r.city,
    area: r.area,
    // ✅ ADDED: Latitude and longitude fields
    latitude: r.latitude || "",
    longitude: r.longitude || ""
  }));
  
  const pageIds = mappedRestaurants.map(r => r.id);
  const allPageSelected = pageIds.length > 0 && pageIds.every(id => selected.has(id));
  const toggleAll = () => setSelected(prev => { 
    const next = new Set(prev); 
    if (allPageSelected) {
      pageIds.forEach(id => next.delete(id)); 
    } else {
      pageIds.forEach(id => next.add(id)); 
    }
    return next; 
  });
  const toggleOne = (id) => setSelected(prev => { 
    const n = new Set(prev); 
    if (n.has(id)) {
      n.delete(id); 
    } else {
      n.add(id); 
    }
    return n; 
  });
  const clearSelection = () => setSelected(new Set());
  
  const handleDeleteSelected = async () => { 
    try { 
      showToast(`${selected.size} restaurant(s) deleted`); 
      clearSelection(); 
      setShowDeleteModal(null); 
      fetchRestaurants();
    } catch (err) { 
      showToast(`Delete failed: ${err.message}`, "error"); 
    } 
  };
  
  const handleDeleteFromDetail = async (restaurant) => { 
    setShowDeleteModal(restaurant); 
  };
  
  const openScheduleModal = (restaurant) => {
    setScheduleRestaurant(restaurant);
    setScheduleItems(restaurant.schedule && restaurant.schedule.length > 0 ? restaurant.schedule : [
      { day: "Monday", openTime: "09:00", closeTime: "17:00", isClosed: false },
      { day: "Tuesday", openTime: "09:00", closeTime: "17:00", isClosed: false },
      { day: "Wednesday", openTime: "09:00", closeTime: "17:00", isClosed: false },
      { day: "Thursday", openTime: "09:00", closeTime: "17:00", isClosed: false },
      { day: "Friday", openTime: "09:00", closeTime: "17:00", isClosed: false },
      { day: "Saturday", openTime: "09:00", closeTime: "17:00", isClosed: false },
      { day: "Sunday", openTime: "09:00", closeTime: "17:00", isClosed: false }
    ]);
    setShowScheduleModal(true);
  };
  
  const addScheduleItem = (newItem) => {
    if (scheduleItems.some(item => item.day === newItem.day)) {
      showToast("Schedule for this day already exists", "error");
      return;
    }
    setScheduleItems([...scheduleItems, { ...newItem }]);
  };
  
  const updateScheduleItem = (index, updatedItem) => { 
    const updated = [...scheduleItems]; 
    updated[index] = updatedItem; 
    setScheduleItems(updated); 
  };
  
  const deleteScheduleItem = (index) => setScheduleItems(scheduleItems.filter((_, i) => i !== index));
  
  const saveSchedule = async () => {
    try {
      showToast("Opening/Closing times updated successfully");
      setShowScheduleModal(false);
      fetchRestaurants();
      if (showDetailPage && showDetailPage.id === scheduleRestaurant.id) {
        setShowDetailPage({ ...showDetailPage, schedule: scheduleItems });
      }
    } catch (err) {
      showToast(`Failed to save schedule: ${err.message}`, "error");
    }
  };
  
  const totalPages = Math.ceil(total / perPage);
  
  // Column widths - optimized to fit without horizontal scroll
  const columnWidths = {
    checkbox: "32px",
    sn: "40px",
    id: "55px",
    logo: "44px",
    status: "70px",
    ready: "55px",
    onoff: "55px",
    open: "60px",
    close: "60px",
    restaurant: "120px",
    owner: "100px",
    rating: "65px",
    payments: "80px",
    contact: "95px",
    actions: "75px"
  };
  
  const styles = {
    container: { minHeight: "100vh", background: isDark ? "#0d1117" : "#f8fafc", fontFamily: "'DM Sans', sans-serif", padding: "16px 20px" },
    headerActions: { display: "flex", gap: "10px", marginBottom: "16px" },
    addBtn: { background: "#4a6cf7", color: "white", border: "none", padding: "8px 16px", borderRadius: "8px", cursor: "pointer", fontWeight: 600, fontSize: "12px", display: "flex", alignItems: "center", gap: "5px" },
    filtersBar: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px", flexWrap: "wrap", gap: "12px" },
    searchWrapper: { position: "relative", flex: 1, maxWidth: "300px" },
    searchInput: { width: "100%", padding: "8px 10px 8px 32px", background: isDark ? "#141824" : "#ffffff", border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", borderRadius: "8px", fontSize: "12px", color: isDark ? "#f1f5f9" : "#1e293b", outline: "none" },
    searchIcon: { position: "absolute", left: "10px", top: "50%", transform: "translateY(-50%)", color: "#3b82f6" },
    filterControls: { display: "flex", gap: "15px", alignItems: "center", flexWrap: "wrap" },
    filterGroup: { display: "flex", alignItems: "center", gap: "6px", fontSize: "11px", color: isDark ? "#64748b" : "#475569" },
    select: { padding: "5px 8px", background: isDark ? "#141824" : "#ffffff", border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", borderRadius: "5px", color: isDark ? "#f1f5f9" : "#1e293b", cursor: "pointer", fontSize: "11px" },
    showHidden: { display: "flex", alignItems: "center", gap: "5px", fontSize: "11px", color: isDark ? "#64748b" : "#475569" },
    locationFilterContainer: { 
      display: "flex", alignItems: "center", gap: "10px", padding: "6px 12px",
      background: isDark ? "#141824" : "#ffffff", border: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`,
      borderRadius: "8px", marginBottom: "14px", flexWrap: "wrap"
    },
    locationSelect: { padding: "6px 10px", background: isDark ? "#0d1117" : "#f8fafc", border: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`, borderRadius: "5px", color: isDark ? "#f1f5f9" : "#1e293b", cursor: "pointer", fontSize: "11px", minWidth: "160px" },
    locationStat: { fontSize: "10px", color: isDark ? "#94a3b8" : "#64748b", padding: "3px 8px", background: isDark ? "#1e2740" : "#f1f5f9", borderRadius: "16px", display: "inline-flex", alignItems: "center", gap: "4px" },
    selectionBar: { display: "flex", alignItems: "center", gap: "10px", background: "rgba(59,130,246,0.1)", border: "1px solid rgba(59,130,246,0.25)", borderRadius: "8px", padding: "6px 12px", marginBottom: "10px", flexWrap: "wrap" },
    tableWrapper: { background: isDark ? "#141824" : "#ffffff", border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", borderRadius: "12px", overflow: "hidden", width: "100%" },
    table: { width: "100%", borderCollapse: "collapse", tableLayout: "fixed" },
    th: (width) => ({ 
      padding: "10px 6px", textAlign: "left", fontSize: "10px", fontWeight: 700, 
      color: "#3b82f6", borderBottom: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", 
      background: isDark ? "#0f1520" : "#f8fafc", width: width || "auto",
      whiteSpace: "nowrap"
    }),
    td: { 
      padding: "8px 6px", borderBottom: isDark ? "1px solid #1a2035" : "1px solid #f1f5f9", 
      fontSize: "11px", color: isDark ? "#e2e8f0" : "#1e293b",
      whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"
    },
    pagination: { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 16px", borderTop: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", background: isDark ? "#0f1520" : "#f8fafc", flexWrap: "wrap", gap: "10px" },
    viewMoreBtn: { background: "#3b82f6", color: "white", border: "none", padding: "3px 8px", borderRadius: "4px", cursor: "pointer", fontSize: "9px", fontWeight: 500, whiteSpace: "nowrap" },
    restaurantName: { fontWeight: 600, fontSize: "11px", maxWidth: "110px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: "inline-block" },
    ratingWrapper: { display: "flex", alignItems: "center", gap: "3px", fontSize: "10px", whiteSpace: "nowrap" },
    paymentWrapper: { display: "flex", alignItems: "center", gap: "3px", fontSize: "10px", whiteSpace: "nowrap" },
    idText: { fontFamily: "monospace", fontSize: "9px", color: "#3b82f6" },
    contactText: { fontSize: "10px", whiteSpace: "nowrap" }
  };

  if (showDetailPage) {
    return (
      <RestaurantDetailPage
        restaurant={showDetailPage}
        onBack={() => setShowDetailPage(null)}
        onEdit={(restaurant) => handleEditRestaurantClick(restaurant)}
        onDelete={(restaurant) => handleDeleteFromDetail(restaurant)}
        onViewSchedule={(restaurant) => openScheduleModal(restaurant)}
        onViewMenu={(restaurant) => setShowMenuModal(restaurant)}
        isDark={isDark}
      />
    );
  }

  return (
    <div style={styles.container}>
      <style>{`
        @keyframes slideUp { from{transform:translateY(20px);opacity:0} to{transform:translateY(0);opacity:1} }
        @keyframes fadeIn { from{opacity:0} to{opacity:1} }
        @media (max-width: 1200px) { body { font-size: 11px; } }
      `}</style>

      <div style={styles.headerActions}>
        <button style={styles.addBtn} onClick={handleAddRestaurantClick}>
          <PlusIcon /> Add Restaurant
        </button>
      </div>

      <div style={styles.filtersBar}>
        <div style={styles.searchWrapper}>
          <span style={styles.searchIcon}><SearchIcon /></span>
          <input type="text" style={styles.searchInput} placeholder="Search..." value={search} onChange={(e) => setSearch(e.target.value)} />
        </div>
        <div style={styles.filterControls}>
          <label style={styles.showHidden}>
            <input type="checkbox" /> Show Hidden
          </label>
          <div style={styles.filterGroup}>
            <label>Status:</label>
            <select style={styles.select} value={statusFilter} onChange={(e) => { setStatusFilter(e.target.value); setPage(1); }}>
              <option>All</option><option>Active</option><option>Inactive</option>
            </select>
          </div>
          <div style={styles.filterGroup}>
            <label>Ready:</label>
            <select style={styles.select} value={readyFilter} onChange={(e) => { setReadyFilter(e.target.value); setPage(1); }}>
              <option>All</option><option>Yes</option><option>No</option>
            </select>
          </div>
          <div style={styles.filterGroup}>
            <label>ON/OFF:</label>
            <select style={styles.select} value={onOffFilter} onChange={(e) => { setOnOffFilter(e.target.value); setPage(1); }}>
              <option>All</option><option>ON</option><option>OFF</option>
            </select>
          </div>
        </div>
      </div>

      <div style={styles.locationFilterContainer}>
        <LocationPinIcon style={{ color: "#3b82f6", width: "12px", height: "12px" }} />
        <span style={{ fontSize: "11px", fontWeight: 600, color: isDark ? "#f1f5f9" : "#1e293b" }}>Location:</span>
        <select style={styles.locationSelect} value={locationFilter} onChange={(e) => { setLocationFilter(e.target.value); setPage(1); }}>
          {uniqueLocations.map((location, idx) => (
            <option key={idx} value={location}>
              {location} {location !== "All" && `(${locationStats[location] || 0})`}
            </option>
          ))}
        </select>
        <div style={{ display: "flex", gap: "5px", flexWrap: "wrap", marginLeft: "auto" }}>
          {Object.entries(locationStats).slice(0, 3).map(([location, count]) => (
            <span key={location} style={styles.locationStat}>
              <LocationPinIcon style={{ width: "8px", height: "8px" }} />
              {location}: {count}
            </span>
          ))}
          {Object.keys(locationStats).length > 3 && (
            <span style={styles.locationStat}>+{Object.keys(locationStats).length - 3} more</span>
          )}
        </div>
      </div>

      {selected.size > 0 && (
        <div style={styles.selectionBar}>
          <span style={{ fontSize: "11px", color: "#93c5fd", fontWeight: 600 }}>✓ {selected.size} selected</span>
          <div style={{ flex: 1 }} />
          <button onClick={clearSelection} style={{ padding: "3px 8px", borderRadius: "5px", border: "1px solid #3b4460", background: "#1e2740", color: "#94a3b8", fontSize: "10px", cursor: "pointer" }}>Clear</button>
          <button onClick={() => setShowDeleteModal({ id: Array.from(selected), name: `${selected.size} restaurants` })} style={{ padding: "3px 8px", borderRadius: "5px", border: "1px solid rgba(239,68,68,0.3)", background: "rgba(239,68,68,0.1)", color: "#ef4444", fontSize: "10px", cursor: "pointer", display: "flex", alignItems: "center", gap: "4px" }}><TrashIcon /> Delete</button>
        </div>
      )}

      <div style={styles.tableWrapper}>
        <div style={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th(columnWidths.checkbox)}><Checkbox checked={allPageSelected} onChange={toggleAll} /></th>
                <th style={styles.th(columnWidths.sn)}>#</th>
                <th style={styles.th(columnWidths.id)}>ID</th>
                <th style={styles.th(columnWidths.logo)}>Logo</th>
                <th style={styles.th(columnWidths.status)}>Status</th>
                <th style={styles.th(columnWidths.ready)}>Ready</th>
                <th style={styles.th(columnWidths.onoff)}>ON/OFF</th>
                <th style={styles.th(columnWidths.open)}>Open</th>
                <th style={styles.th(columnWidths.close)}>Close</th>
                <th style={styles.th(columnWidths.restaurant)}>Restaurant</th>
                <th style={styles.th(columnWidths.owner)}>Owner</th>
                <th style={styles.th(columnWidths.rating)}>Rating</th>
                <th style={styles.th(columnWidths.payments)}>Payments</th>
                <th style={styles.th(columnWidths.contact)}>Contact</th>
                <th style={styles.th(columnWidths.actions)}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array.from({ length: perPage }).map((_, i) => (
                  <tr key={`skeleton-${i}`}>
                    {Array.from({ length: 15 }).map((_, j) => (
                      <td key={`skeleton-cell-${i}-${j}`} style={styles.td}>
                        <div style={{ height: "10px", background: isDark ? "#1e2740" : "#e2e8f0", borderRadius: "3px", width: j === 0 ? "12px" : "70%" }} />
                      </td>
                    ))}
                  </tr>
                ))
              ) : mappedRestaurants.length === 0 ? (
                <tr><td colSpan={15} style={{ padding: "50px", textAlign: "center", color: "#64748b", fontSize: "12px" }}>{debouncedSearch ? "No results" : "No restaurants found"}</td></tr>
              ) : (
                mappedRestaurants.map((restro) => (
                  <tr key={restro.id} style={{ background: selected.has(restro.id) ? "rgba(59,130,246,0.07)" : "transparent" }}>
                    <td style={styles.td}><Checkbox checked={selected.has(restro.id)} onChange={() => toggleOne(restro.id)} /></td>
                    <td style={styles.td}>{restro.sn}</td>
                    <td style={styles.td}><span style={styles.idText}>{restro.restroId}</span></td>
                    <td style={styles.td}>
                      <RestaurantAvatar 
                        pic={restro.pic} 
                        name={restro.organisation_name || restro.name} 
                        isDark={isDark} 
                      />
                    </td>
                    <td style={styles.td}><StatusBadge status={restro.status} /></td>
                    <td style={styles.td}><ReadyBadge ready={restro.ready} /></td>
                    <td style={styles.td}><OnOffBadge value={restro.onOff} /></td>
                    <td style={styles.td}>{restro.shiftStart || "-"}</td>
                    <td style={styles.td}>{restro.shiftEnd || "-"}</td>
                    <td style={styles.td}><span style={styles.restaurantName} title={restro.organisation_name || restro.name}>{restro.organisation_name || restro.name || "N/A"}</span></td>
                    <td style={styles.td}><span title={restro.owner_name}>{restro.owner_name || "-"}</span></td>
                    <td style={styles.td}><div style={styles.ratingWrapper}><StarIcon /> {restro.rating || 0} ({restro.totalRatings || 0})</div></td>
                    <td style={styles.td}><div style={styles.paymentWrapper}><PaymentIcon /> ₹{(restro.totalPayments || 0).toLocaleString()}</div></td>
                    <td style={styles.td}><span style={styles.contactText}>{restro.contact}</span></td>
                    <td style={styles.td}><button style={styles.viewMoreBtn} onClick={() => setShowDetailPage(restro)}>View</button></td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div style={styles.pagination}>
          <span style={{ fontSize: "10px", color: "#64748b" }}>{loading ? "Loading..." : `${Math.min((page-1)*perPage+1, total)}–${Math.min(page*perPage, total)} of ${total}`}</span>
          <div style={{ display: "flex", gap: "3px", flexWrap: "wrap" }}>
            <button onClick={() => setPage(p => Math.max(1, p-1))} disabled={page === 1 || loading} style={{ width: "26px", height: "26px", borderRadius: "5px", border: "1px solid #1e2740", background: "#141824", color: page === 1 ? "#2d3a55" : "#94a3b8", cursor: "pointer", fontSize: "10px" }}><ChevronLeftIcon /></button>
            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => { 
              let p; 
              if (totalPages <= 5) p = i + 1;
              else if (page <= 3) p = i + 1;
              else if (page >= totalPages - 2) p = totalPages - 4 + i;
              else p = page - 2 + i;
              return p <= totalPages && (
                <button key={p} onClick={() => setPage(p)} style={{ width: "26px", height: "26px", borderRadius: "5px", fontSize: "10px", border: page === p ? "1px solid #3b82f6" : "1px solid #1e2740", background: page === p ? "#1e3a8a" : "#141824", color: page === p ? "#93c5fd" : "#64748b", cursor: "pointer" }}>{p}</button>
              ); 
            })}
            <button onClick={() => setPage(p => Math.min(totalPages, p+1))} disabled={page === totalPages || loading} style={{ width: "26px", height: "26px", borderRadius: "5px", border: "1px solid #1e2740", background: "#141824", color: page === totalPages ? "#2d3a55" : "#94a3b8", cursor: "pointer", fontSize: "10px" }}><ChevronRightIcon /></button>
          </div>
        </div>
      </div>

      <DeleteConfirmModal isOpen={!!showDeleteModal} restaurantName={showDeleteModal?.name || showDeleteModal?.organisation_name || ""} onConfirm={() => {
        if (showDeleteModal?.id === Array.from(selected) && selected.size > 0) handleDeleteSelected();
        else if (showDeleteModal?.id) { showToast("Restaurant deleted"); setShowDeleteModal(null); fetchRestaurants(); if (showDetailPage && showDetailPage.id === showDeleteModal.id) setShowDetailPage(null); }
        else if (showDeleteModal?.id && Array.isArray(showDeleteModal.id)) handleDeleteSelected();
      }} onCancel={() => setShowDeleteModal(null)} isDark={isDark} />
      
      <ScheduleModal isOpen={showScheduleModal} restaurant={scheduleRestaurant} scheduleItems={scheduleItems} onUpdate={updateScheduleItem} onDelete={deleteScheduleItem} onAdd={addScheduleItem} onClose={() => { setShowScheduleModal(false); setScheduleRestaurant(null); }} onSave={saveSchedule} isDark={isDark} />
      
      {showMenuModal && <RestaurantMenuModal restaurant={showMenuModal} onClose={() => setShowMenuModal(null)} isDark={isDark} />}
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
    </div>
  );
};

export default RestaurantTable;